import React from "react";
import { Link } from "react-router-dom";
import { INDUSTRY_PAGE_SLUGS } from "../../../services/contentApi";
import "./IndustryDropdown.css";

export { INDUSTRY_PAGE_SLUGS };

export const INDUSTRIES_DROPDOWN_ITEMS = [
  {
    title: "Mobility",
    desc: "Smart transportation & logistics.",
    to: "/mobility",
  },
  {
    title: "Healthcare",
    desc: "Secure digital patient care.",
    to: "/healthcare",
  },
  {
    title: "Retail & E-commerce",
    desc: "Scalable shopping experiences.",
    to: "/retail-ecommerce",
  },
  {
    title: "FinTech",
    desc: "High-performance financial systems.",
    to: "/fintech",
  },
  {
    title: "Travel & Hospitality",
    desc: "Seamless booking & engagement.",
    to: "/travel-hospitality",
  },
  {
    title: "High-tech & Software",
    desc: "Engineering for digital products.",
    to: "/high-tech-software",
  },
  {
    title: "Telecom & Media",
    desc: "Content delivery & data systems.",
    to: "/telecom-media",
  },
  {
    title: "Real Estate & Construction",
    desc: "Modern property management tools.",
    to: "/real-estate-construction",
  },
  {
    title: "AI & Data Intelligence",
    desc: "Data-driven automation & insights.",
    to: "/ai-data-intelligence",
  },
];

const IndustryDropdown = () => {
  return (
    <div className="industries-dropdown">
      <div className="industries-dropdown__inner">
        {INDUSTRIES_DROPDOWN_ITEMS.map((item, index) => (
          <Link key={index} to={item.to} className="industrydrop-card">
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default IndustryDropdown;
